import { Search } from "components-new";
import { FC, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ReactComponent as LoadingIcon } from "images/load.svg";
import { useAppDispatch } from "toolkit/hooks";
import { addEmployee } from "toolkit/steps/stepOne/stepOne.slice";
import cn from "classnames";
import styles from "./AddingEmployees.module.sass";
import { IEmployeeShort } from "toolkit/employees/types";
import {employeesAPI} from "libs/apiClient/Employees";

const AddingEmployees: FC = () => {
	const dispatch = useAppDispatch();

	const { organizationId, commissionId } = useParams();

	const [activeTab, setActiveTab] = useState<number>(0);
	const [searchValue, setSearchValue] = useState<string>("");

	const [data, setData] = useState<{
		employees: IEmployeeShort[];
		filteredEmployees: IEmployeeShort[];
		loading: boolean;
	}>({
		employees: [],
		filteredEmployees: [],
		loading: true,
	});

	const [params] = useState({
		page: 1,
		num: 999999,
	});

	useEffect(() => {
		setData((prevState: any) => ({ ...prevState, loading: true }));

		if (activeTab) {
			employeesAPI.shortList({ ...params, query: searchValue } ).then((data) =>
				setData({
					employees: data.data,
					filteredEmployees: data.data,
					loading: false,
				}),
			);
		} else {
			employeesAPI.shortList({ ...params, org: +organizationId!, query: searchValue } )
				.then((data) =>
					setData({
						employees: data.data,
						filteredEmployees: data.data,
						loading: false,
					}),
				);
		}
		//eslint-disable-next-line
	}, [activeTab, searchValue]);

	// useEffect(() => {
	// 	if (!searchValue) {
	// 		setData((prevState) => ({
	// 			...prevState,
	// 			filteredEmployees: data.employees,
	// 		}));
	//
	// 		return;
	// 	}
	//
	// 	const newData = data.employees.filter((employee) => {
	// 		const name = `${employee.lastName} ${employee.firstName} ${employee.middleName}`;
	//
	// 		const result = name.toLowerCase().includes(searchValue.toLowerCase());
	// 		return result;
	// 	});
	//
	// 	setData((prevState) => ({
	// 		...prevState,
	// 		filteredEmployees: [...newData],
	// 	}));
	// }, [searchValue]);

	useEffect(() => {
		if (searchValue) {
			setSearchValue("");
		}
		//eslint-disable-next-line
	}, [activeTab]);

	return (
		<div className={styles.addingEmployees}>
			<div className={styles.tabs}>
				<div className={cn(styles.tab, { [styles.active]: activeTab === 0 })} onClick={() => setActiveTab(0)}>
					Сотрудники организации
				</div>
				<div className={cn(styles.tab, { [styles.active]: activeTab === 1 })} onClick={() => setActiveTab(1)}>
					Все сотрудники
				</div>
			</div>

			<div className={styles.item}>
				<div className={styles.title}>Выберите участников комиссии</div>
				<Search
					handleSearch={(e) => setSearchValue(e.target.value)}
					searchValue={searchValue}
					className={styles.search}
				/>

				<div data-comment-false={true} className={styles.employees}>
					{data.loading ? (
						<LoadingIcon className={styles.loaderIcon} />
					) : data.filteredEmployees.length ? (
						data.filteredEmployees.map((employee) => (
							<div
								className={styles.employee}
								key={employee.id}
								onClick={() => dispatch(addEmployee({ employee, commissionId }))}>
								{/*{employee.lastName} {employee.firstName} {employee.middleName}*/}
								{employee.fullName}
							</div>
						))
					) : (
						<div className={styles.empty}>Не удалось найти сотрудников</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default AddingEmployees;
